import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldComponent } from './field/field.component';
import { StpMaterialModule } from '../material/material.module';
import { FieldGroupComponent } from './field-group/field-group.component';
import { FieldDataDirective } from './field-data.directive';
import { StpFormsModule } from '../../stp-app/forms/forms.module';

@NgModule({
  imports: [
    CommonModule,
    StpFormsModule,
    StpMaterialModule
  ],
  exports: [
    FieldComponent,
    FieldGroupComponent,
    FieldDataDirective
  ],
  declarations: [
    FieldComponent,
    FieldGroupComponent,
    FieldDataDirective
  ]
})
export class StpFieldModule { }
